import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from 'vbrick-player-src/pipes/Pipes.Module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SharedModule } from '../../shared/Shared.Module';

import { VbScrubBarChapterComponent } from './VbScrubBarChapter.Component';
import { VbScrubBarCurrentTimeBubbleComponent } from './VbScrubBarCurrentTimeBubble.Component';
import { VbScrubBarCurrentTimeComponent } from './VbScrubBarCurrentTime.Component';
import { VbScrubBarProgressComponent } from './VbScrubBarProgress.Component';
import { VbScrubBarWithChaptersComponent } from './VbScrubBarWithChapters.Component';
import { VbTimeMarkersComponent } from './VbTimeMarkers.Component';
import { VgChaptersMenuComponent } from './VgChaptersMenu.Component';
import { VgControlsComponent } from './VgControls.Component';
import { VgFullscreenButtonComponent } from './VgFullscreenButton.Component';
import { VgMuteButtonComponent } from './VgMuteButton.Component';
import { VgPlayPauseButtonComponent } from './VgPlayPauseButton.Component';
import { VgScrubBarComponent } from './VgScrubBar.Component';
import { VgScrubBarPreviewComponent } from './VgScrubBarPreview.Component';
import { VgScrubBarScrubberComponent } from './VgScrubBarScrubber.Component';
import { VgSeekComponent } from './VgSeek.Component';
import { VgSkipChapterComponent } from './VgSkipChapter.Component';
import { VgToggleChapterDisplayButtonComponent } from './VgToggleChapterDisplayButton.Component';
import { VgVolumeBarComponent } from './VgVolumeBar.Component';
import { VgVolumeComponent } from './VgVolume.Component';

const components = [
	VbScrubBarChapterComponent,
	VbScrubBarCurrentTimeBubbleComponent,
	VbScrubBarCurrentTimeComponent,
	VbScrubBarProgressComponent,
	VbScrubBarWithChaptersComponent,
	VbTimeMarkersComponent,
	VgChaptersMenuComponent,
	VgControlsComponent,
	VgFullscreenButtonComponent,
	VgMuteButtonComponent,
	VgPlayPauseButtonComponent,
	VgScrubBarComponent,
	VgScrubBarPreviewComponent,
	VgScrubBarScrubberComponent,
	VgSeekComponent,
	VgSkipChapterComponent,
	VgToggleChapterDisplayButtonComponent,
	VgVolumeBarComponent,
	VgVolumeComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		PipesModule,
		SharedModule,
		TooltipModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	]
})
export class VideogularControlsModule {}
